module.exports = __webpack_public_path__ + "img/公司业务—培训.2e829cac.jpg";